/**
 * 画面モード記録用ファイル
 */
// tslint:disable-next-line:no-namespace
export namespace ScreenMode {
    // 画面モード
    /** 操作モード　参照 */
    export const READ = 'READ';
    /** 操作モード　作成 */
    export const CREATE = 'CREATE';
    /** 操作モード　更新 */
    export const UPDATE = 'UPDATE';
}
